export default __webpack_public_path__ + "static/media/spotify.dc923657.svg";